
/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import 'react-dates/initialize';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController,isInclusivelyBeforeDay } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
import $ from 'jquery';


/*Components*/
import DateRange from '../../components/dateRangePicker/dateRange';
import SelectBox from '../../components/formComponents/selectBox';
import APILoader from '../../components/other/api-loader';
import NoDataFound from '../../components/other/nothing';
import ImageUploader from '../../services/upload/imageUploader';
import Input from '../../components/formComponents/input';
import LazyLoaderGif from '../../components/common/lazyloader';

/*Services*/
import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';
import APIGet from '../../services/apiCall/get';


/*Assets*/
import Download from '../../assets/images/download-icon-dark.svg';
import noResultImg from '../../assets/images/empty.svg';

class BusinessListing  extends Component {
  constructor(props){
    super(props);
    this.state = {
      category: null,
      dateFilter: false,
      initalDate: moment().format(),
      startDate: moment().startOf('month'),
      endDate: moment(),
      data: [],
      profile_completed:false,
      apiLoading: false,
      category_ids: [],
      SubCategoryData: [],
      SubProductData: [],
      sub_category_ids: [],
      productData : [],
      selectedSubCatIds: [],
      selectedprod: [],
      logo: null,
      productLoading: false
    }
  }

  async componentWillMount() {
    this.getData();
    var localStorageData = localStorage.getItem("vendor_data");
    if(localStorageData){
      var parsedData = JSON.parse(localStorageData);
      if(parsedData.seller_type>1){
        await this.setState({profile_completed: parsedData.profile_completed, category_ids:parsedData.department_ids});
        this.getSubCategoryData(parsedData.department_ids);
      }
      else{
        await this.setState({profile_completed: parsedData.profile_completed, category_ids:parsedData.category_ids});
        this.getSubCategoryData(parsedData.category_ids);
      }
      this.setState({vendorType: parsedData.seller_type});
    }
  }

  async getSubCategoryData(category_ids){
    this.setState({apiLoading: true});
    if(localStorage.getItem("vendor_data") && JSON.parse(localStorage.getItem("vendor_data")).seller_type>1){
      var url = devconfig.vendor+'department/list';
      await APIGet(url, data).then(function(response){
        if(response.status == "ok"){
          let temp=[];
          category_ids.forEach(id=>{
            response.data.forEach(department=>{
              if(department.id == id){
                department.category.forEach(category=>{
                  temp.push({id: category.id, sub_category: category.name});
                })
              }
            });
          });
          this.setState({SubCategoryData: temp,apiLoading: false});
        }
      }.bind(this))
    }
    else{
      var url = devconfig.vendor+'subcategory/list';
      var data = JSON.stringify({
        "category_ids": category_ids
      });
      await APIPost(url, data).then(function(response){
        if(response.status == "ok"){
          this.setState({SubCategoryData: response.data,apiLoading: false});
        }
      }.bind(this))
    }
  }

  productChange(sub_category_ids){
    var tempSubCatIds = this.state.selectedSubCatIds;
    var index = tempSubCatIds.indexOf(sub_category_ids);
    if( index === -1){
      tempSubCatIds.push(sub_category_ids);
      this.setState({selectedSubCatIds: tempSubCatIds});
      this.productAPI(tempSubCatIds);
    }else{
      var tempVal = $.grep(tempSubCatIds, function(value) {
        return value != sub_category_ids;
      });
      this.setState({selectedSubCatIds: tempVal})
      this.productAPI(tempVal);
    }
  }

  async productAPI(tempItem){
    this.setState({productLoading: true});
    var url = devconfig.vendor+'product/list';
    var data = JSON.stringify({
      "sub_category_ids": tempItem
    })
    if(localStorage.getItem("vendor_data") && JSON.parse(localStorage.getItem("vendor_data")).seller_type>1){
      url = devconfig.vendor+'subcategory/list';
      data = JSON.stringify({
        "category_ids": tempItem
      });
    }
    APIPost(url, data).then(function(response){
      if(response.status == "ok"){
        this.setState({productData: response.data, productLoading: false})
      }
      else{
        this.setState({productLoading: false})
      }
    }.bind(this))
  }


  productSelect(tempId){
    var tempSubCatIds = this.state.selectedprod;
    var index = tempSubCatIds.indexOf(tempId);
    if( index === -1){
      tempSubCatIds.push(tempId);
      this.setState({selectedprod: tempSubCatIds});
    }
    else{
      var tempVal = $.grep(tempSubCatIds, function(value) {
        return value != tempId;
      });
      this.setState({selectedprod: tempVal})
    }
  }
  getData(){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+'business/list';
    var data = JSON.stringify({
      "startDate": this.state.startDate,
      "endDate": this.state.endDate
    })
    APIPost(url, data).then(function(response){
      if(response.status == "ok"){
        this.setState({data: response.data,apiLoading: false});
      }
    }.bind(this))
  }

  dateChange(tempStart, tempEnd){
    var url = devconfig.vendor+'business/list';
    var data = JSON.stringify({
      "start_date": tempStart,
      "end_date": tempEnd
    })
     APIPost(url,data).then(function(response){
      if(response.status == "ok"){
        this.setState({ data: response.data});
      }
    }.bind(this))

  }
  profileCompleted(){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+'auth/complete-profile';
    var data = JSON.stringify({
      "logo": this.state.logo,
      "website": this.state.website,
      "sub_category_ids": this.state.selectedSubCatIds,
      "product_ids": this.state.selectedprod

    });
    if(this.state.vendorType>1){
      data = JSON.stringify({
        "logo": this.state.logo,
        "website": this.state.website,
        "category_ids": this.state.selectedSubCatIds,
        "sub_category_ids": this.state.selectedprod
  
      });
    }
    APIPost(url, data).then(function(response){
      if(response.status == "ok"){
        

        var localStorageData = localStorage.getItem("vendor_data");
        if(localStorageData){
          var parsedData = JSON.parse(localStorageData);
          parsedData.profile_completed = true;
          localStorage.setItem("vendor_data", JSON.stringify(parsedData));
          window.location.reload(true);
        }

      }
    }.bind(this))
  }


  async uploadSucess(url, data){
    this.setState({logo:url})
  }
  async uploadStatus(status){
    this.setState({uploading: status})
  }
  chooseImage(){
    $("#e-dp-uploader").click();
  }


  render() {

    return (
      <div>
        {
          this.state.apiLoading ?
            <APILoader/>
          :
          <div className="e-main-content e-vendor-table e-scheduled-ads-wrap e-buisness-list">
            <h2 className="e-page-head">My Business Listing</h2>
            {
              this.state.data ?
                <div>
                {

                  this.state.profile_completed ?
                  <div>
                    <div className="row">
                      <div className="col-lg-3">
                        <h6 className="mb-3">Filter by</h6>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-lg-5 col-md-3 col-sm-6 col-12">
                        <DateRange isOutsideRange={true} dateChange={this.dateChange.bind(this)}/>
                      </div>
                    </div>
                    {/*<div className="row mb-3">
                      <div className="col-lg-10">
                        <a href="#" className="e-download e-download-icon float-right">Download</a>
                      </div>
                    </div>*/}

                    {
                      this.state.data && this.state.data.length ?
                        <div className="row">
                          {
                            this.state.data.map((item,index) => {
                              return(
                                <div className="col-lg-6 col-md-8 col-sm-12 col-12 mb-4">
                                  <div className="e-vendor-category-list e-card">
                                    <div className="row e-advertisement">
                                      <div className="col-lg-5 col-md-6 col-sm-6 col-12">
                                        <h1>{item.total_views}</h1>
                                        <p>{item.type} views</p>
                                      </div>
                                      <div className="col-lg-5 col-md-6 col-sm-6 col-12">
                                        <h1>{item.total_clicks}</h1>
                                        <p>{item.type} clicks</p>
                                      </div>
                                    </div>
                                    <div className="row pt-4 pl-3">
                                      <div className="col-lg-6 col-m-6 col-sm-6 col-6 e-line">
                                        <h5 className="e-advertisement-type mb-4">{item.type == "Offers" ? "Offers" : "Ad's"}</h5>
                                      </div>
                                      <div className="col-lg-3 col-md-3 col-sm-3 col-3 e-line">
                                         <h5 className="e-advertisement-type mb-4">View</h5>
                                      </div>
                                      <div className="col-lg-3 col-md-3 col-sm-3 col-3 e-line">
                                         <h5 className="e-advertisement-type mb-4">Click</h5>
                                      </div>
                                    </div>
                                    {
                                      item.detail.map((subItem,index) => {
                                        return(
                                          <div className="row pt-3 e-advertisement-content">
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                                              <p>{subItem.type}</p>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                                              <p>{subItem.views}</p>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                                              <p>{subItem.clicks}</p>
                                            </div>
                                          </div>
                                        );
                                      })
                                    }
                                  </div>
                                </div>
                              );
                            })
                          }
                        </div>
                      :
                        <div className='text-center e-b-listing-purchase-wrap'>
                          <img className="e-no-result" src={noResultImg} alt="No data found"/>
                          <div className="e-noData-txt">No ads analytics found! Change filter or purchase new plan</div>
                        </div>
                    }
                    
                  </div>
                  :

                  <div className="row">
                    <div className="col-lg-6">
                      <div className="e-vendor-category-list">
                        <div className="row">
                          <div className="e-new-store col-lg-12">
                            <h5 className="mb-2">Add new online store</h5>
                          </div>

                          <div className="col-lg-4">
                            <div className="e-subcategory-content ">
                              {
                                this.state.uploading ?
                                  <span className="e-upload-btn e-store e-b-list-logo-uploader text-center mb-3"></span>
                                :
                                  <React.Fragment>
                                    {
                                      this.state.logo ?
                                        <span className="e-b-list-logo">
                                          <span className="e-close-icon" onClick={(e) => this.setState({logo: null})}></span>
                                          <img src={this.state.logo}/>
                                        </span>
                                      :
                                        <span className="e-upload-btn e-store text-center mb-3" onClick={this.chooseImage.bind(this)}>Upload your online store logo</span>
                                    }
                                  </React.Fragment>
                              }
                            
                            </div>
                          </div>
                          <div className="col-lg-8">
                            <div className="e-note-wrap">
                              <p className="e-note pl-3 pt-2">*Note</p>
                              <p className="e-note-content pb-2 pl-3">Logo must be square (400px * 400px)</p>
                            </div>
                          </div>
                        </div>
                        <div className="row e-website-link">
                          <div className="col-lg-12">
                            <Input id="e-web" type="text" className="e-deal-link e-profile-website" valueChange={(tempVal) => this.setState({website: tempVal})} placeholder="Website link" />
                          </div>
                        </div>
                        <div className="row e-online-subcategory pt-2">
                          <div className="col-lg-12 ">
                          <div className="e-border">
                            <div className="row pl-3">

                              <h5>Select online sub-category</h5>
                              {/*<div className="custom-control custom-checkbox e-check mb-3">
                                <input type="checkbox" className="custom-control-input" id="customCheck"/>
                                <label className="custom-control-label pt-1" for="customCheck">Select all</label>
                              </div>*/}
                            </div>
                            <div className="row">
                            {
                              this.state.SubCategoryData.map((item,index) => {

                                return(
                                  <div className="col-lg-4">
                                    <div className="custom-control custom-checkbox mb-3" onClick={(e)=>{ e.preventDefault(); this.productChange(item.id) } }>
                                      <input type="checkbox" checked={this.state.selectedSubCatIds.indexOf(item.id)!= -1} className="custom-control-input" id={"customCheck"+item.id}/>
                                      <label className="custom-control-label pt-1 e-collections" for={"customCheck"+item.id}>{item.sub_category}</label>
                                    </div>
                                  </div>
                                );
                              })
                            }
                            </div>
                            {/*<div className="row">
                              <a href="#" className="e-new-category">Add New Sub-category</a>
                            </div>*/}

                            </div>
                          </div>
                        </div>
                        {
                          this.state.productLoading ?
                            <React.Fragment>
                              <LazyLoaderGif/>
                            </React.Fragment>
                          :
                            <React.Fragment>

                              {
                                this.state.productData &&  this.state.productData.length ?
                                  <React.Fragment>
                                    <div className="row e-online-subcategory pt-3">
                                      <div className="col-lg-12 ">
                                        <div className="e-border">
                                          <div className="row">
                                            {
                                              this.state.productData.map((item, index)=>{
                                                return(
                                                  <div className="col-lg-4">
                                                    <div className="custom-control custom-checkbox mb-3" onClick={(e)=>{this.productSelect(item.id) } }>
                                                      <input type="checkbox" className="custom-control-input" checked={this.state.selectedprod.indexOf(item.id)!= -1} />
                                                      <label className="custom-control-label pt-1 e-collections">{localStorage.getItem("vendor_data") && JSON.parse(localStorage.getItem("vendor_data")).seller_type>1? item.sub_category :item.product}</label>
                                                    </div>
                                                  </div>
                                                 );
                                              })
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </React.Fragment>
                                :
                                  <div className="row e-online-subcategory pt-3">
                                    <div className="col-lg-12 ">
                                      <div className="e-border">
                                        <p className="mb-0 pb-0">No prodouct found. Select a category.</p>
                                      </div>
                                    </div>
                                  </div>
                              }
                            </React.Fragment>
                        }
                        
                        <div className="row mt-4">
                          <div className="col-lg-12">
                            {
                              this.state.website && this.state.logo && this.state.selectedprod.length && this.state.selectedSubCatIds.length ?
                                <button className="e-s-btn" type="submit" value="Submit" onClick={this.profileCompleted.bind(this)}>Submit</button>
                              :
                               <button className="e-s-btn e-inactive" type="submit" value="Submit">Submit</button>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                }
                </div>
              :
                <NoDataFound head="Nothing Found"/>
            }
          </div>
        }
        <ImageUploader
          tempKey="/user/pan-card"
          className="hidden"
          style={{display: 'none'}}
          id="e-dp-uploader"
          accept="image/*"
          uploadStatus={this.uploadStatus.bind(this)}
          uploadSucess={this.uploadSucess.bind(this)}
        />
      </div>
    );
  }
}

export default BusinessListing;
